import React from 'react';
import { useNavigate } from 'react-router-dom';

import { SvgCardType } from '../../components/svg-card/svg-card-types';
import { RadioAlternativ } from '../../sporsmalsflyt/reducer/sporsmalsflyt-types';
import { Skademeldingstype } from '../../types/generated-types';
import { skadeUrlFromSkadetype } from '../../urler';
import { GruppeLandingsside } from '../gruppe-landingsside';
import { KategoriSvarId } from '../sporsmal-og-svar';

const alternativer: RadioAlternativ[] = [
    {
        id: KategoriSvarId.BygningNaturskadeStorm,
        tekst: 'Storm',
    },
    {
        id: KategoriSvarId.BygningNaturskadeFlom,
        tekst: 'Flom',
    },
    {
        id: KategoriSvarId.BygningNaturskadeSkred,
        tekst: 'Skred',
    },
    {
        id: KategoriSvarId.BygningNaturskadeAnnen,
        tekst: 'Annen naturskade',
        undertekst: 'Det gjelder jordskjelv, flodbølge, meteorittnedslag og vulkanutbrudd',
    },
];

export const BygningNaturskade = () => {
    const navigate = useNavigate();
    const onNext = (svarId: KategoriSvarId) => {
        if (svarId === KategoriSvarId.BygningNaturskadeStorm) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningNaturskadeStorm));
        } else if (svarId === KategoriSvarId.BygningNaturskadeFlom) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningNaturskadeFlom));
        } else if (svarId === KategoriSvarId.BygningNaturskadeSkred) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningNaturskadeSkred));
        } else if (svarId === KategoriSvarId.BygningNaturskadeAnnen) {
            navigate(skadeUrlFromSkadetype(Skademeldingstype.BygningNaturskadeAnnen));
        }
    };

    const goback = () => navigate(-1);
    return (
        <GruppeLandingsside
            title="Naturskade"
            onNext={onNext}
            navigateToParent={goback}
            alternativer={alternativer}
            svgCardType={SvgCardType.HusEnkelt}
            radioButtonsLabel="Hvilken type naturhendelse har skadet bygningen?"
            kategoriId="bygning-naturskade"
        />
    );
};
